/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem
 */
export interface ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem
     */
    event_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem
     */
    event_data?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem
     */
    message?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem
     */
    created_by?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem
     */
    created_date?: Date | null;
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemFromJSON(json: any): ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem {
    return ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_type': !exists(json, 'event_type') ? undefined : json['event_type'],
        'event_data': !exists(json, 'event_data') ? undefined : json['event_data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'created_by': !exists(json, 'created_by') ? undefined : json['created_by'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
    };
}

export function ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItemToJSON(value?: ControlcenterMelcoControlCenterModelsDigitizingOrderHistoryItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_type': value.event_type,
        'event_data': value.event_data,
        'message': value.message,
        'created_by': value.created_by,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
    };
}


